import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function StarFilled({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>StarFilled</title>
      <path
        d="M11.5375 3.11139C11.6697 3.03487 11.8205 2.99641 11.9731 3.00026V3.03968C12.1308 3.03579 12.2862 3.077 12.4212 3.15846C12.5562 3.23992 12.6651 3.35825 12.7352 3.49952L15.3628 8.54459L21.3276 9.21464C21.4704 9.23396 21.605 9.29273 21.7163 9.38434C21.8276 9.47596 21.9112 9.5968 21.9576 9.73328C22.004 9.86976 22.0114 10.0165 21.979 10.1569C21.9466 10.2974 21.8757 10.4261 21.7743 10.5285L17.4255 14.5882L18.424 20.1194C18.4413 20.2352 18.4331 20.3534 18.3998 20.4657C18.3665 20.578 18.309 20.6816 18.2313 20.7693C18.1537 20.857 18.0578 20.9265 17.9503 20.9731C17.8429 21.0198 17.7265 21.0422 17.6094 21.039C17.477 21.0383 17.3466 21.0068 17.2284 20.9471L11.9731 18.3194L6.71786 20.9471C6.60971 20.9922 6.49343 21.0145 6.37627 21.0128C6.25919 21.016 6.14284 20.9935 6.03539 20.9469C5.92795 20.9003 5.83202 20.8307 5.75437 20.743C5.67672 20.6553 5.61922 20.5517 5.58593 20.4394C5.55265 20.3271 5.54437 20.2089 5.5617 20.0931L6.5602 14.5619L2.22459 10.5153C2.12311 10.4129 2.0522 10.2843 2.01981 10.1438C1.98743 10.0033 1.99486 9.85662 2.04126 9.72014C2.08766 9.58366 2.17121 9.46282 2.2825 9.37121C2.3938 9.27959 2.52843 9.22082 2.67129 9.2015L8.59662 8.4789L11.2243 3.43383C11.2969 3.2995 11.4054 3.18791 11.5375 3.11139Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
